import { render, staticRenderFns } from "./viewPicture.vue?vue&type=template&id=c4c66aa6"
import script from "./viewPicture.vue?vue&type=script&lang=js"
export * from "./viewPicture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports